<!-- Main Content Area -->
<div class="min-h-screen bg-gradient-to-br from-purple-50/50 via-white to-indigo-50/50 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900 lg:ml-80">
    
    <!-- Beta Badge - Solo en beta -->
    <div *ngIf="isBeta" class="fixed top-4 left-4 z-50 lg:top-6 lg:left-6">
        <div class="bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 rounded-full shadow-xl backdrop-blur-sm border border-orange-400 animate-pulse">
            <div class="flex items-center space-x-2">
                <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                </svg>
                <span class="font-mono text-sm font-bold tracking-wide">BETA {{version}}</span>
            </div>
        </div>
    </div>
    
    <!-- Beta Banner - Solo en beta -->
    <div *ngIf="isBeta" class="mx-4 lg:mx-8 mt-4 lg:mt-6">
        <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 border border-blue-200 dark:border-blue-800 rounded-2xl p-4">
            <div class="flex items-center space-x-3">
                <div class="w-10 h-10 bg-blue-100 dark:bg-blue-900/50 rounded-full flex items-center justify-center">
                    <svg class="w-5 h-5 text-blue-600 dark:text-blue-400" fill="currentColor" viewBox="0 0 20 20">
                        <path d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"/>
                    </svg>
                </div>
                <div>
                    <h3 class="font-mono font-semibold text-blue-800 dark:text-blue-200">Versión BETA</h3>
                    <p class="font-mono text-sm text-blue-600 dark:text-blue-300">Funciones experimentales activas - Tu feedback es valioso</p>
                </div>
            </div>
        </div>
    </div>
    
    <!-- Experimental Features - Solo en beta -->
    <div *ngIf="isBeta" class="mx-4 lg:mx-8 mt-4">
        <div class="bg-gradient-to-r from-yellow-50 to-orange-50 dark:from-yellow-900/20 dark:to-orange-900/20 border border-yellow-200 dark:border-yellow-800 rounded-2xl p-4">
            <div class="flex items-center space-x-3">
                <span class="text-2xl">🧪</span>
                <p class="font-mono text-yellow-800 dark:text-yellow-200 font-medium">
                    Función en desarrollo - Úsala con precaución
                </p>
            </div>
        </div>
    </div>

    <!-- Header Section -->
    <div class="px-3 lg:px-6 py-4 lg:py-6">
      <!-- Mood Selector -->
      <div class="mb-6">
        <div class="flex justify-between items-center mb-3">
          <h2 class="font-mono text-lg font-semibold text-gray-700 dark:text-gray-300">¿Cómo te sientes hoy?</h2>
          <div class="text-right">
            <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-xl px-3 py-2 border border-purple-100 dark:border-slate-700">
              <p class="font-mono text-xs text-gray-500 dark:text-gray-400 mb-1">Hoy</p>
              <p class="font-mono text-sm font-semibold text-purple-600 dark:text-purple-400">{{fecha}}</p>
            </div>
          </div>
        </div>
        <div class="relative">
          <button 
            type="button" 
            (click)="toggleDropdown()" 
            class="w-full lg:w-auto min-w-[250px] font-mono rounded-xl border-2 px-4 py-3 shadow-md transition-all duration-200 flex items-center justify-between hover:shadow-lg focus:outline-none focus:ring-4 focus:ring-purple-500/20"
            [ngClass]="feelingSelected ? getSelectedFeelingColor() + ' border-transparent' : 'bg-gradient-to-r from-indigo-100 to-purple-100 dark:from-slate-700 dark:to-slate-600 border-purple-300 dark:border-slate-600 text-gray-700 dark:text-gray-300'">
            
            <span class="flex items-center space-x-2">
              <span class="text-lg">{{ feelingSelected ? getFeelingEmoji(feelingSelected) : '🎭' }}</span>
              <span class="font-medium text-sm">{{ feelingSelected || 'Selecciona tu estado de ánimo' }}</span>
            </span>
            
            <svg class="w-4 h-4 transition-transform duration-200" [class.rotate-180]="showDropdown" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>
          
          <div *ngIf="showDropdown" 
               class="absolute top-full left-0 right-0 lg:right-auto lg:min-w-[250px] mt-2 bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-xl shadow-xl border border-gray-200 dark:border-slate-700 z-20 overflow-hidden">
            <div class="p-1">
              <div 
                *ngFor="let feeling of feelings"
                (click)="selectFeeling(feeling.name)"
                class="font-mono px-3 py-2 cursor-pointer rounded-lg transition-all duration-200 flex items-center space-x-2 hover:scale-105"
                [ngClass]="feeling.color + ' hover:shadow-lg'">
                <span class="text-xl">{{ feeling.emoji }}</span>
                <span class="font-medium">{{ feeling.name }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Main Writing Area -->
    <div class="px-3 lg:px-6 pb-6">
      <form class="space-y-4" [formGroup]="reliefForm" (ngSubmit)="newDaily()">
        
        <!-- Auto-delete Option -->
        <div class="bg-white/60 dark:bg-slate-800/60 backdrop-blur-sm rounded-xl p-4 border border-purple-100 dark:border-slate-700">
          <label class="flex items-start space-x-3 cursor-pointer group">
            <div class="relative">
              <input 
                type="checkbox" 
                formControlName="deleteIn24h"
                class="sr-only">
              <div class="w-5 h-5 bg-white dark:bg-slate-700 border-2 border-gray-300 dark:border-slate-600 rounded-md flex items-center justify-center transition-all duration-200 group-hover:border-purple-400 dark:group-hover:border-purple-400"
                   [class.bg-purple-500]="reliefForm.get('deleteIn24h')?.value"
                   [class.border-purple-500]="reliefForm.get('deleteIn24h')?.value">
                <svg *ngIf="reliefForm.get('deleteIn24h')?.value" class="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd"/>
                </svg>
              </div>
            </div>
            <div class="flex-1">
              <div class="flex items-center space-x-2 mb-1">
                <span class="text-lg">🗑️</span>
                <span class="text-gray-800 dark:text-gray-200 font-mono font-semibold text-sm">Auto-eliminación en 24 horas</span>
              </div>
              <p class="text-xs text-gray-600 dark:text-gray-400 font-mono leading-relaxed">
                Tu Relief se eliminará automáticamente después de 24 horas para mayor privacidad y tranquilidad mental.
              </p>
            </div>
          </label>
        </div>

        <!-- Writing Area -->
        <div class="relative">
          <div class="bg-white/40 dark:bg-slate-800/40 backdrop-blur-sm rounded-2xl border border-purple-100 dark:border-slate-700 shadow-xl overflow-hidden">
            <div class="p-4 lg:p-6">
              <textarea 
                formControlName="relief" 
                placeholder="{{fraseRandom}}"
                class="w-full h-64 lg:h-80 bg-transparent border-none resize-none focus:outline-none font-mono text-base lg:text-lg text-purple-600 dark:text-purple-400 placeholder-purple-600 dark:placeholder-purple-400 leading-relaxed">
              </textarea>
            </div>
            
            <!-- Character Count -->
            <div class="px-4 pb-3">
              <div class="flex justify-between items-center text-xs font-mono text-gray-500 dark:text-gray-400">
                <span>Escribe libremente, sin límites</span>
                <span>{{reliefForm.get('relief')?.value?.length || 0}} caracteres</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Submit Button -->
        <div class="flex justify-center lg:justify-end">
          <button 
            type="submit" 
            [disabled]="!reliefForm.get('relief')?.value?.trim()"
            class="group bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 disabled:from-gray-400 disabled:to-gray-500 text-white font-mono font-bold px-6 py-3 lg:px-8 lg:py-4 rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 disabled:hover:scale-100 disabled:cursor-not-allowed flex items-center space-x-2 text-base lg:text-lg">
            <span>Crear Relief</span>
            <svg class="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>
            </svg>
          </button>
        </div>
      </form>
    </div>
</div>

<!-- Modal -->
<div *ngIf="showModal" class="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-50">
  <div class="bg-white/95 dark:bg-slate-800/95 backdrop-blur-lg rounded-2xl shadow-xl p-6 w-full max-w-sm mx-4 border border-purple-100 dark:border-slate-700">
    <div class="text-center">
      <div class="w-12 h-12 bg-gradient-to-r from-red-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg class="w-6 h-6 text-white" fill="currentColor" viewBox="0 0 20 20">
          <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
        </svg>
      </div>
      <h2 class="font-mono text-xl font-bold text-gray-800 dark:text-gray-200 mb-3">¡Oops!</h2>
      <p class="font-mono text-gray-600 dark:text-gray-300 mb-6 leading-relaxed text-sm">{{ modalMessage }}</p>
      <button 
        (click)="closeModal()" 
        class="w-full font-mono py-3 px-4 bg-gradient-to-r from-purple-500 to-indigo-600 hover:from-purple-600 hover:to-indigo-700 text-white rounded-xl font-semibold hover:shadow-lg transition-all duration-200 hover:scale-105 text-sm">
        Entendido
      </button>
    </div>
  </div>
</div>